export const hasSessionStorage = () => {
  try {
    if (!('sessionStorage' in window) || window.sessionStorage == null)
      return false;

    window.sessionStorage.setItem('test', 'test');
    const value = window.sessionStorage.getItem('test');

    if (value !== 'test') return false;

    window.sessionStorage.removeItem('test');

    return true;
  } catch (err) {
    return false;
  }
};
